<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="tvandroid" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Thank you, company
                </div>

                <div>
                  has been successfully changed!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Emergency Add
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-tabs
                v-model="selected_menu"
                background-color="transparent"
                :color="set_color"
                slider-size="5"
                show-arrows
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                dense
                grow
                class="d-flex justify-start">
                <v-tab
                  v-for="(item, index) in menus"
                  :disabled="item.disabled">
                  <span 
                    class="body-2 text-capitalize" 
                    :class="selected_menu === index ? 'font-weight-bold' : 'text-third'">
                    {{ item.text }}
                  </span>
                </v-tab>
              </v-tabs>
              
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text v-if="selected_menu < 1">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4">
                          <div
                            class="mb-6">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
    
                              Route Plan
                            </div>
    
                            <folder v-if="form.image_url === ''"
                              v-model="upload.folder">
                              <div 
                                slot="activator">
                                <v-card 
                                  flat
                                  width="100%"
                                  height="300"
                                  class="d-flex align-center justify-center cursor-pointer"
                                  style="border-radius: 10px;
                                        border: 2px solid #EBEBEB; 
                                        border-style: dashed;">
                                  <v-avatar v-if="!process.file"
                                    v-ripple
                                    tile 
                                    width="100%"
                                    height="300">
                                    <v-icon
                                      size="50"
                                      color="#B9B9B9">
                                      mdi-cloud-upload-outline
                                    </v-icon>
                                  </v-avatar>
    
                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-card>
                              </div>
                            </folder>
    
                            <v-card v-if="form.image_url !== ''"
                              flat
                              color="#BDBDBD"
                              width="100%"
                              height="300"
                              class="d-flex align-center justify-center"
                              style="border-radius: 10px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.file"
                                v-ripple
                                tile 
                                width="100%"
                                height="300">
                                <v-img 
                                  contain
                                  width="100%"
                                  height="100%"
                                  alt="tvandroid" 
                                  :src="form.image_url"
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar>
    
                              <v-icon 
                                @click="form.image_url = ''"
                                color="red"
                                class="cursor-pointer"
                                style="position: absolute; top: -10px; right: -10px;">
                                mdi-close-circle
                              </v-icon>
                            </v-card>
                          </div>
                        </v-col>
                        
                        <v-col
                          cols="12"
                          md="8">
                          <v-row>
                            <v-col
                              cols="12"
                              md="9"
                              class="py-0">
                              <ValidationProvider 
                                name="Title" 
                                rules="required|max:256" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Title
                                </div>

                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Ex : 1st floour route."
                                  :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                  v-model="form.title"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col
                              cols="12"
                              md="3"
                              class="py-0">
                              <ValidationProvider 
                                name="Status" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>
    
                                  Status
                                </div>
    
                                <v-select
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  rounded
                                  dense
                                  
                                  :color="set_color"
                                  placeholder="Ex : Active"
                                  :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                                  
                                  :items="[
                                    {
                                      text: 'Active',
                                      value: true
                                    },
                                    {
                                      text: 'Not Active',
                                      value: false
                                    }
                                  ]"
                                  item-text="text"
                                  item-value="value"
                                  :item-color="set_color"

                                  clearable
                                  @click:clear="form.is_active_bool = ''"
                                  
                                  v-model="form.is_active_bool"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-select>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          
                          <ValidationProvider 
                            name="Content" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Content
                            </div>

                            <v-textarea
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              rows="4"

                              :color="set_color"
                              placeholder="Ex : Emergency Evacuation Plan"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.note"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>

                          <div
                            class="d-flex align-center mt-2">
                            <uploadaudio 
                              v-model="upload.audio">
                              <div slot="activator">
                                <v-btn
                                  color="blue"
                                  elevation="0"
                                  class="text-capitalize white--text"
                                  style="border-radius: 10px;"
                                  :disabled="process.audio"
                                  :loading="process.audio">
                                  <v-icon>mdi-book-music</v-icon>

                                  <span
                                    class="ml-2">
                                    Upload Audio
                                  </span>
                                </v-btn>
                              </div>
                            </uploadaudio>

                            <div v-if="!show_audio"
                              class="ml-6">
                              <audio 
                                controls>
                                <source>
                              </audio>
                            </div>

                            <div v-if="show_audio"
                              class="ml-6">
                              <audio 
                                controls>
                                <source
                                  :src="form.audio_url">
                              </audio>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>

                <v-card-text v-else>

                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected_menu: 0,

        menus: [
          {
            text: 'Content',
            value: 'content',
            disabled: false
          },
          {
            text: 'TV Device',
            value: 'tv_device',
            disabled: true
          }
        ],


        show: false,
        show_audio: false,

        dialog: {
          success: false,
          color: false
        },

        form: {
          id: '',
          title: '',
          note: '',
          image_url: '',
          audio_url: '',
          is_active_bool: ''
        },

        picker: {
          time: false
        },

        upload: {
          folder: null,
          audio: null
        },

        process: {
          form: false,

          file: false,
          audio: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      folder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploadaudio: () => import(/* webpackPrefetch: true */ '@/components/upload/audio.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.folder.file_url
            }
          }
        },
        deep: true
      },

      'upload.audio': {
        handler: function () {
          if (this.upload.audio) {
            this.process.audio = this.upload.audio.process

            this.show_audio = false

            if (!this.process.audio) {
              // CALLBACK FROM UPLOAD DOC

              this.form.audio_url = this.upload.audio.file_url

              setTimeout(() => {
                this.show_audio = true
              }, 1000)
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/emergency/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.$router.push(`/extra/emergency/edit/${res.result.id}?menu=1`)
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>